import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiRestService } from '../api-rest/api-rest.service';

@Injectable({
  providedIn: 'root',
})
export class ApiHappylandService {
  environment = environment.endpoints.status;
  envSecure = environment.endpoints.secure;
  envRegister = environment.endpoints.register;
  timezoneOffSet = new Date().getTimezoneOffset();
  private urlReturnTo = environment.endpoints.returnTo;

  constructor(private api: ApiRestService) {}

  async requestTokenJWT(card: string): Promise<HttpResponse<{ code: number; status: boolean; token: string }>> {
    try {
      const headers = new HttpHeaders().set('Content-Type', 'application/json');
      const params = {
        account: card,
        src: environment.endpoints.returnTo,
      };

      const response = await this.api.postQuery(`${this.envSecure}/auth/jwt`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async checkIfCardIsEnable(card: string): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        account: card,
        UTCoffsetMinutes: -this.timezoneOffSet,
      };

      const response = await this.api.postQuery(`${this.environment}/itahue/card`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async getCardID(url: string): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const response = await this.api.getQuery(url, headers);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }
  /**
   *
   * @param dni
   * @param email
   * @param corpID
   * @param promotionUid
   * @param transactionToken
   * @param timestamp
   * @returns
   */
  async generateInvoiceAndCharge(
    dni: string,
    email: string,
    corpID: string,
    promotionUid: string,
    transactionToken: string,
    timestamp: number,
    retryInvoice: number
  ): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        corpID: corpID,
        dni: dni,
        email: email,
        timestamp: timestamp,
        token: transactionToken,
        promotionUid: promotionUid,
        retry: retryInvoice,
      };

      const response = await this.api.postQuery(`${this.envSecure}/itahue/invoiceAndCharge`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async registerAndAssignCard(
    userInformation: { email: string; firstName: string; lastName: string; phoneNumber?: number },
    corpID: number,
    account: string,
    checkPromotions: boolean
  ): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        email: userInformation.email,
        firstName: userInformation.firstName,
        lastName: userInformation.lastName,
        phoneNumber: userInformation.phoneNumber,
        corpID: corpID,
        account: account,
        isPromotionRequested: checkPromotions,
      };

      const response = await this.api.postQuery(`${this.envRegister}/itahue/registerAndAsignCard`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async validateTransactionStatus(promotionUid: string, transactionToken: string, timestamp: number): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        token: transactionToken,
        timestamp: timestamp,
        promotionUid: promotionUid,
      };

      const response = await this.api.postQuery(`${this.envSecure}/itahue/validate`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async requestHistoryInformationByCard(account: number): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        account: account,
        // UTCoffsetMinutes: -this.timezoneOffSet,
      };

      const response = await this.api.postQuery(`${this.environment}/itahue/card/historical`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      // Error in Happyland service
      return Promise.reject(errCritical);
    }
  }

  /**
   * Obtener la configuración personalizada del usuario
   * @param settings
   * @returns
   */
  async verifyIfUserHaveOffers(account: number): Promise<HttpResponse<any>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const response = await this.api.getQuery(`${this.environment}/itahue/segment?account=${account}`, headers);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  /**
   * Obtener la configuración personalizada del usuario
   * @param settings
   * @returns
   */
  async createNewTransactionWithPaymentAmountZero(
    account: number,
    promotionUid: string,
    email: string
  ): Promise<HttpResponse<{ message: string; data: { token: string; timestamp: number } }>> {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        account: account,
        email: email,
        promotionUID: promotionUid,
        returnTo: this.urlReturnTo,
      };

      const response = await this.api.postQuery(`${this.envSecure}/itahue/segments/createPaymentProcess`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }

  async requestReloadFromLastTransactionWithPaymentAmountZero(
    transactionUID: string,
    transactionTimestamp: number
  ): Promise<
    HttpResponse<{
      message: string;
      data: {
        url: string;
        folio: number;
        reload: any;
      };
    }>
  > {
    try {
      const bearerAuthorization = sessionStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${bearerAuthorization}`).set('Content-Type', 'application/json');

      const params = {
        token: transactionUID,
        timestamp: transactionTimestamp,
      };

      const response = await this.api.postQuery(`${this.envSecure}/itahue/segments/invoiceAndCharge`, headers, params);
      return Promise.resolve(response);
    } catch (errCritical) {
      return Promise.reject(errCritical);
    }
  }
}
